module.exports = __webpack_public_path__ + "media/door.7c9cb742.mp3";